import React, { useEffect, useState } from 'react';
import { ToggleButtonGroup, OverlayTrigger, Badge } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { FiltersButton } from './FiltersButton';
import { Envelope, Book, Cursor } from 'react-bootstrap-icons';

interface MessagesFiltersProps {
  onFilterChange: (filter: string) => void;
}

export enum MessagesFilterTypes {
  all = 'all',
  unread = 'unread',
  read = 'read'
}

const availableFilters = Object.keys(MessagesFilterTypes);

export const MessagesFilters = (props: MessagesFiltersProps) => {
  const { hash } = useLocation();
  const history = useHistory();

  const filter = ((hash && availableFilters.find((f) => hash.includes(f))) || null) ?? MessagesFilterTypes.all;

  const [selectedFilter, setSelectedFilter] = useState(filter);

  const onFilterChange = (newFilter: string) => {
    history.push(`#${newFilter}`);
    setSelectedFilter(newFilter);
    props.onFilterChange(newFilter);
  };

  useEffect(() => {
    if (!selectedFilter) return;

    props.onFilterChange(selectedFilter);
  }, [props.onFilterChange, selectedFilter]);

  const renderFilterButton = (label: string, value: string, icon: React.ReactNode) => {
    const isSelected = selectedFilter === value;
    return (
      <Badge
        pill
        bg={isSelected ? 'primary' : ''}
        className={`msg-filters ${isSelected ? 'selected' : ''}`}
        onClick={(e: React.MouseEvent<HTMLSpanElement>) => {
          e.preventDefault();
          onFilterChange(value);
        }}>
        {icon}
        {label}
      </Badge>
    );
  };

  return (
    <div className='d-flex align-items-center' style={{ gap: '10px' }}>
      <span className='text-dark'>Show:</span>
      <ToggleButtonGroup name='patients-filters' type='radio' style={{ gap: '10px' }}>
        {renderFilterButton('All', MessagesFilterTypes.all, <i className='fa-regular fa-books me-1'></i>)}
        {renderFilterButton('Read', MessagesFilterTypes.read, <i className='fa-regular fa-book-open me-1'></i>)}
        {renderFilterButton('Unread', MessagesFilterTypes.unread, <i className='fa-regular fa-book me-1'></i>)}
      </ToggleButtonGroup>
    </div>
  );
};
